import { render, staticRenderFns } from "./BestPriceBookie.vue?vue&type=template&id=bac8ec0e&"
import script from "./BestPriceBookie.vue?vue&type=script&lang=js&"
export * from "./BestPriceBookie.vue?vue&type=script&lang=js&"
import style0 from "./BestPriceBookie.vue?vue&type=style&index=0&id=bac8ec0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports